import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useInviteOrganizationAdminValidationSchema = () => {
  const { t } = useTranslation(['organizationAdmins']);

  return z.object({
    email: z
      .string()
      .email(t('organizationAdmins:validation.inviteEmailError'))
      .min(1, t('organizationAdmins:validation.inviteEmailRequired')),
    role: z.union([z.literal('owner'), z.literal('admin')]),
    friendlyName: z.string().optional(),
  });
};
